import { render, staticRenderFns } from "./CampaignsTable.vue?vue&type=template&id=295ee894&scoped=true&"
import script from "./CampaignsTable.vue?vue&type=script&lang=js&"
export * from "./CampaignsTable.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsTable.vue?vue&type=style&index=0&id=295ee894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295ee894",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('295ee894')) {
      api.createRecord('295ee894', component.options)
    } else {
      api.reload('295ee894', component.options)
    }
    module.hot.accept("./CampaignsTable.vue?vue&type=template&id=295ee894&scoped=true&", function () {
      api.rerender('295ee894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/campaigns/CampaignsTable.vue"
export default component.exports